import React from 'react';
import { Controller, UseControllerProps } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Box, Typography } from '@mui/material';

interface ControlledEditorProps {
  label: string;
  id: string;
  name: string;
  control: any;
  rules?: UseControllerProps['rules'];
  defaultValue?: string;
  description?: string;
  disabled?:boolean
}

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['blockquote', 'code-block'],
    [{ align: [] }],
    [{ script: 'sub' }, { script: 'super' }],
    [{ indent: '-1' }, { indent: '+1' }],
    ['link', 'image'],
    ['clean'],
  ],
};

const formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
  'code-block',
  'script',
  'align',
];

const WSEditor: React.FC<ControlledEditorProps> = ({
  label,
  id,
  name,
  control,
  rules,
  defaultValue = '',
  description,
  disabled=false
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState }) => (
        <Box>
          {/* Label */}
          <Typography variant="body1" sx={{ mb: 1 }}>
            {label}
          </Typography>

          {/* Description (Optional) */}
          {description && (
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
              {description}
            </Typography>
          )}

          {/* ReactQuill Editor */}
          <Box   className="editor-container"
            sx={{
              border: fieldState.error
                ? '1px solid red'
                : '1px solid #ccc',
              borderRadius: '8px',
              overflow: 'hidden',
            }}
          >
            <ReactQuill
              {...field}
              theme="snow"
              style={{backgroundColor:disabled?'lightgrey':undefined}}
              modules={modules}
              formats={formats}
              readOnly={disabled}
              placeholder="Type your message here..."
             // style={{ height: '10rem' }}
              onChange={(content) => field.onChange(content)}

            />
          </Box>

          {/* Error Handling */}
          {/* {fieldState?.error && (
            <Typography variant="body2" sx={{ color: 'red', mt: 1 }}>
              {fieldState.error.message || 'Invalid input'}
            </Typography>
          )} */}
        </Box>
      )}
    />
  );
};

export default WSEditor;
